import { useContext } from 'react';
import PropTypes from 'prop-types';
import _isNil from 'lodash/isNil';
import { getChildrenContainer, getChildrenContent } from './Content.utils';
import useResponsive from '../../../../hooks/use-responsive';
import { createComponent } from '../../../../modules/foundation/services/components';
import { ChildrenPropType, ObjectPropsPropType } from '../../../../services/proptypes';
import { HoverContainerContext } from '../../HoverContainer.context';
var propTypes = {
  children: ChildrenPropType,
  content: ChildrenPropType,
  displayOnTouchScreen: PropTypes.bool,
  animation: PropTypes.oneOfType([PropTypes.string]),
  animationProps: ObjectPropsPropType
};
var defaultProps = {
  children: null,
  content: null,
  displayOnTouchScreen: null,
  animation: null,
  animationProps: {}
};
function Content(_ref) {
  var children = _ref.children,
    content = _ref.content,
    displayOnTouchScreen = _ref.displayOnTouchScreen,
    animation = _ref.animation,
    animationProps = _ref.animationProps;
  var _useResponsive = useResponsive(),
    isTouchScreenDevice = _useResponsive.isTouchScreenDevice;
  var _useContext = useContext(HoverContainerContext),
    isHovered = _useContext.isHovered,
    _useContext$displayOn = _useContext.displayOnTouchScreen,
    globalDisplayOnTouchScreen = _useContext$displayOn === void 0 ? true : _useContext$displayOn;
  var finalDisplayOnTouchScreen = !_isNil(displayOnTouchScreen) ? displayOnTouchScreen : globalDisplayOnTouchScreen;
  var ChildrenContent = getChildrenContent(children || content, isHovered, {
    displayOnTouchScreen: finalDisplayOnTouchScreen,
    isTouchScreenDevice: isTouchScreenDevice,
    animation: animation
  });
  var ChildrenContainer = getChildrenContainer(animation, animationProps, isHovered);
  if (isTouchScreenDevice || _isNil(ChildrenContainer)) {
    return ChildrenContent;
  }
  return createComponent(ChildrenContainer, {
    children: ChildrenContent
  });
}
Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
export default Content;